module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("首页版本设置")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新建")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": "版本号",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "当前状态",
      "width": "180"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.global[0] && _vm.global[0].SettingValue) ? _c('div', [(_vm.row.version === _vm.global[0].SettingValue[_vm.row.refer]) ? _c('span', {
            staticStyle: {
              "color": "#67C23A"
            }
          }, [_vm._v("激活中")]) : _c('span', {
            staticStyle: {
              "color": "#999"
            }
          }, [_vm._v("未激活")])]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户端来源",
      "context": _vm._self
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v(_vm._s(_vm.referList[_vm.row.refer]))])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "版本名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "创建时间",
      "context": _vm._self
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "150",
      "label": "操作",
      "align": "right"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.global[0] && _vm.global[0].SettingValue) ? _c('span', [(_vm.row.version !== _vm.global[0].SettingValue[_vm.row.refer]) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleLive(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("激活")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), (_vm.Role !== '0' && (_vm.row.version !== _vm.global[0].SettingValue)) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDelete(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")]) : _vm._e()], 1) : _vm._e()
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建首页版本"
    },
    model: {
      value: (_vm.addVersion),
      callback: function($$v) {
        _vm.addVersion = $$v
      },
      expression: "addVersion"
    }
  }, [_c('el-form', {
    ref: "versionForm",
    attrs: {
      "model": _vm.versionForm,
      "rules": _vm.addVersionRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "版本号",
      "label-width": "120px",
      "prop": "version"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.versionForm.version),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "version", $$v)
      },
      expression: "versionForm.version"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "版本名称",
      "label-width": "120px",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.versionForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "remark", $$v)
      },
      expression: "versionForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户端来源",
      "label-width": "120px",
      "prop": "remark"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.versionForm.refer),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "refer", $$v)
      },
      expression: "versionForm.refer"
    }
  }, _vm._l((_vm.referList), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "基于某个版本",
      "label-width": "120px",
      "prop": "base"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "基于版本"
    },
    model: {
      value: (_vm.versionForm.base),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "base", $$v)
      },
      expression: "versionForm.base"
    }
  }, _vm._l((_vm.versionOption), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.version,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('versionForm')
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑首页版本"
    },
    model: {
      value: (_vm.editVersion),
      callback: function($$v) {
        _vm.editVersion = $$v
      },
      expression: "editVersion"
    }
  }, [_c('el-form', {
    ref: "versionForm",
    attrs: {
      "model": _vm.versionForm,
      "rules": _vm.addVersionRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "版本号",
      "label-width": "120px",
      "prop": "version"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.versionForm.version),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "version", $$v)
      },
      expression: "versionForm.version"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "版本名称",
      "label-width": "120px",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.versionForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "remark", $$v)
      },
      expression: "versionForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户端来源",
      "label-width": "120px",
      "prop": "remark"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.versionForm.refer),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "refer", $$v)
      },
      expression: "versionForm.refer"
    }
  }, _vm._l((_vm.referList), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('versionForm')
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-128ec031"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/IndexVersion.vue
// module id = 713
// module chunks = 1